export const HINTS = 'hints';
export const STUDENTS_WITH_REGENERATED_PINS_FIELD_NAME = 'students_with_regenerated_pins';
export const VARIABLES = 'variables';
export const WIZARD = 'wizard';
export const OLYMP_RESULTS = 'olymp_winter_2019_results_seen';
export const TEAMS = 'teams';
export const STUDENTS = 'students';
